var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.0312L15.9375 13.7188C15.25 13.4062 14.4688 13.625 14 14.1875L13.1562 15.2188C11.75 14.4062 10.5938 13.25 9.78125 11.875L10.8438 11.0312C11.375 10.5625 11.5938 9.78125 11.3125 9.125L9.96875 6C9.65625 5.28125 8.875 4.875 8.09375 5.0625L5.25 5.71875C4.5 5.875 4 6.53125 4 7.3125C4 14.875 10.125 21 17.6875 21C18.4688 21 19.125 20.5 19.25 19.75L19.9062 16.9062C20.125 16.125 19.7188 15.3438 19 15.0312ZM18.4688 16.5625L17.8125 19.4062C17.8125 19.4375 17.75 19.5 17.6875 19.5C10.9688 19.5 5.46875 14.0312 5.46875 7.3125C5.46875 7.25 5.53125 7.1875 5.59375 7.1875L8.4375 6.53125L8.46875 6.5C8.53125 6.5 8.5625 6.5625 8.59375 6.59375L9.90625 9.65625C9.9375 9.71875 9.9375 9.78125 9.875 9.8125L8.34375 11.0625C8.09375 11.2812 8 11.6562 8.15625 11.9688C9.1875 14.0625 10.9062 15.7812 13 16.8125C13.3125 16.9688 13.7188 16.9062 13.9375 16.625L15.1875 15.0938C15.2188 15.0625 15.2812 15.0312 15.3438 15.0625L18.4062 16.375C18.4688 16.4375 18.5 16.5 18.4688 16.5625Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.e0cebbc4714ead48c93dadcbf6717205.svg";
export { ForwardRef as ReactComponent };